import useMediaQuery from "../../utils/CustomHooks/useMediaQuery";

const Announcement03 = ({
  color,
  height,
  width,
  mobileWidth,
  mobileHeight,
}) => {
  const isMobile = useMediaQuery("(max-width: 767.99px)");
  return (
    <svg
      width={isMobile ? mobileWidth || width || "18" : width || "20"}
      height={isMobile ? mobileHeight || width || "18" : height || "20"}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="announcement-03">
        <path
          id="Icon"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke={color || "#0E1B1B"}
          d="M15.4166 13.3333C17.0275 13.3333 18.3333 10.9082 18.3333 7.91667C18.3333 4.92512 17.0275 2.5 15.4166 2.5M15.4166 13.3333C13.8058 13.3333 12.5 10.9082 12.5 7.91667C12.5 4.92512 13.8058 2.5 15.4166 2.5M15.4166 13.3333L4.53625 11.3551C3.76334 11.2146 3.37688 11.1443 3.0644 10.9908C2.42868 10.6785 1.95526 10.1113 1.76175 9.42994C1.66663 9.09504 1.66663 8.70225 1.66663 7.91667C1.66663 7.13108 1.66663 6.73829 1.76175 6.40339C1.95526 5.72207 2.42868 5.15481 3.0644 4.84254C3.37688 4.68904 3.76334 4.61878 4.53625 4.47825L15.4166 2.5M4.16663 11.6667L4.49484 16.2617C4.52601 16.698 4.54159 16.9162 4.63652 17.0816C4.7201 17.2272 4.8457 17.3441 4.99687 17.4171C5.16856 17.5 5.3873 17.5 5.82479 17.5H7.31012C7.81024 17.5 8.06031 17.5 8.24539 17.4003C8.40801 17.3126 8.53691 17.1734 8.61182 17.0046C8.69707 16.8124 8.67789 16.5631 8.63953 16.0644L8.33329 12.0833"
        />
      </g>
    </svg>
  );
};

export default Announcement03;
